import { render, staticRenderFns } from "./AddConsideration.vue?vue&type=template&id=4794c0cd&scoped=true"
import script from "./AddConsideration.vue?vue&type=script&lang=js"
export * from "./AddConsideration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4794c0cd",
  null
  
)

export default component.exports